import React from 'react';
import { IconBrandMessenger, IconBolt } from '@tabler/icons-react';
import useMessengerStatus from './useStatus';

const MessengerCard = ({ agentId, context }) => {
  const status = useMessengerStatus(agentId);

  const handleConnect = (e) => {
    e.stopPropagation();
    if (context?.onConnect) context.onConnect('messenger');
  };

  const handleConfigure = (e) => {
    e.stopPropagation();
    if (context?.onSelect) context.onSelect('messenger');
  };

  const cardClass = [
    'channel-card',
    status.isConnected && 'channel-card--connected',
    status.alertSeverity === 'error' && 'channel-card--error',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClass}>
      <div
        className="channel-card__icon"
        style={{
          background: 'linear-gradient(135deg, #0084FF 0%, #0066CC 100%)',
          color: '#fff',
        }}
      >
        <IconBrandMessenger size={22} />
      </div>

      <div className="channel-card__body">
        <h5 className="channel-card__name">
          Messenger
          {status.alertSeverity === 'error' && (
            <IconBolt size={14} style={{ color: '#dc2626' }} />
          )}
        </h5>
        <p className="channel-card__description">
          Mensagens da Página Facebook (DMs do Messenger).
        </p>

        {status.isLoading && (
          <p className="channel-card__summary" style={{ color: '#9ca3af' }}>
            Carregando status...
          </p>
        )}

        {!status.isLoading && status.isConnected && (
          <p className="channel-card__summary">{status.summary}</p>
        )}
      </div>

      <div className="channel-card__footer">
        {status.isConnected ? (
          <>
            <span
              className={`channel-card__status-pill channel-card__status-pill--${status.statusVariant}`}
            >
              {status.statusLabel}
            </span>
            <button
              type="button"
              className="channel-card__cta"
              onClick={handleConfigure}
              style={{ background: '#374151' }}
            >
              Gerenciar
            </button>
          </>
        ) : (
          <>
            <span />
            <button
              type="button"
              className="channel-card__cta"
              onClick={handleConnect}
              style={{ background: '#0084FF' }}
            >
              Conectar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MessengerCard;
